export enum EWidgetProductType {
  EDIT = "edit",
  CREATE = "create",
  DUPLICATE = "duplicate",
  CALCULATION_ERROR = "calculation-error",
}
